import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type {
  IPreviewContractorPaymentDataItem,
  TPostPreviewContractorPaymentDataBody,
} from "./postPreviewContractorPaymentData.schema";

export const postPreviewContractorPaymentData = (axios: IAxiosInstance) => {
  return async (
    body: TPostPreviewContractorPaymentDataBody
  ): Promise<IPreviewContractorPaymentDataItem[]> => {
    const response = await axios.noRetry.post<
      IApiResponse<IPreviewContractorPaymentDataItem[]>
    >("/api/previewContractorPaymentData", body, {
      withCredentials: true,
    });
    const data = response.data;

    if (data.success) {
      return data.data;
    }

    throw new Error("Failed to preview contractor payments");
  };
};
